/**
 * Patients Service
 * Business logic layer for patient-related operations
 */

import { patientsApi } from '../api/endpoints/patients.api';
import type {
  Patient,
  PatientListResponse,
  PatientQueryParams,
  CreatePatientData,
  UpdatePatientData,
} from '../types/patient.types';

export class PatientsService {
  /**
   * Get all patients with pagination and filters
   */
  static async getPatients(params?: PatientQueryParams): Promise<PatientListResponse> {
    return await patientsApi.getPatients(params);
  }

  /**
   * Get single patient by ID
   */
  static async getPatientById(id: string): Promise<Patient> {
    return await patientsApi.getPatientById(id);
  }

  /**
   * Create new patient
   */
  static async createPatient(data: CreatePatientData): Promise<Patient> {
    return await patientsApi.createPatient(data);
  }

  /**
   * Update existing patient
   */
  static async updatePatient(id: string, data: UpdatePatientData): Promise<Patient> {
    return await patientsApi.updatePatient(id, data);
  }

  /**
   * Delete patient (soft delete)
   */
  static async deletePatient(id: string): Promise<{ message: string }> {
    return await patientsApi.deletePatient(id);
  }

  /**
   * Search patients
   */
  static async searchPatients(query: string): Promise<Patient[]> {
    return await patientsApi.searchPatients(query);
  }

  /**
   * Get patient medical history
   */
  static async getPatientHistory(id: string): Promise<any> {
    return await patientsApi.getPatientHistory(id);
  }

  /**
   * Get patient health records
   */
  static async getPatientHealthRecords(patientId: string): Promise<any> {
    return await patientsApi.getPatientHealthRecords(patientId);
  }

  /**
   * Bulk upload patients
   */
  static async bulkUpload(file: File): Promise<{ message: string; count: number; uploadMetadata?: any }> {
    return await patientsApi.bulkUpload(file);
  }

  /**
   * Update patient status
   */
  static async updateStatus(id: string, status: string): Promise<Patient> {
    return await patientsApi.updateStatus(id, status);
  }
}

export default PatientsService;
























